import { Tabs } from "antd";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { DynamicForm, FormConfig } from "~/Components/DynamicForm/DynamicForm";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { useNotification } from "~/Hooks/useNotification";
import { useQuery } from "~/Hooks/useQuery";
import { post, put } from "~/Services";
import { Landing } from "./Landing/Landing";
import { PracticingSensibleEconomics } from "./PracticingSensibleEconomics/PracticingSensibleEconomics";
import { EnvironmentalConsciousness } from "./EnvironmentalConsciousness/EnvironmentalConsciousness";
import { CreatingInspiringWorkplace } from "./CreatingInspiringWorkplace/CreatingInspiringWorkplace";
import { CommunityFriendlyOrganisation } from "./Community/CommunityFriendlyOrganisation";
import { MemorableAirportExperiences } from "./MemorableAirportExepreince/MemorableAirportExperiences";
import { FTSE4Good } from "./FTSE4Good/FTSE4Good";
import { Reports } from "./Reports/Reports";
import { replace } from "lodash";

const Sustainbility = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();
  const approveQuery = new URLSearchParams(location.search);
  const approveId = approveQuery.get("id");

  useEffect(() => {
    if (approveId) {
      return;
    }

    const activeTab = query.get("activeTab");
    const subActiveTab = query.get("subActiveTab");
    const thirdChildActiveTab = query.get("thirdChildActiveTab");

    if (!activeTab) {
      navigate(`/dedicated/corporate/sustainbility?activeTab=${query.get('activeTab') ?? 'landing'}&subActiveTab=${query.get('subActiveTab') ?? 'PractisingSensibleEconomicsForLanding_0'}`, {
        replace: true,
      });
    } else {
      if (activeTab == "landing") {
        navigate(`/dedicated/corporate/sustainbility?activeTab=${query.get('activeTab') ?? 'landing'}&subActiveTab=${query.get('subActiveTab') ?? 'PractisingSensibleEconomicsForLanding_0'}`, {
          replace: true,
        });
      }
      if (activeTab === "practisingSensibleEconomics") {
        const subActiveTab = query.get('subActiveTab') ?? 'MainContent';
        const thirdChildActiveTab = 
          subActiveTab === 'SiderData'
            ? query.get('thirdChildActiveTab') ?? 'GeneratingSustainableReturnsForPracticingSensibleEconomics_0'
            : subActiveTab === 'Features' 
            ? query.get('thirdChildActiveTab') ?? 'GOAL1NoPovertyForPractisingSensibleEconomics_0'
            : query.get('thirdChildActiveTab');
        let url = `/dedicated/corporate/sustainbility?activeTab=practisingSensibleEconomics&subActiveTab=${subActiveTab}`;
        if (thirdChildActiveTab) {
          url += `&thirdChildActiveTab=${thirdChildActiveTab}`;
        }
        navigate(url, { replace: true });
      }
      if (activeTab === "environmentalConsciousness") {
        const subActiveTab = query.get('subActiveTab') ?? 'MainContent';
        const thirdChildActiveTab = 
          subActiveTab === 'SiderData'
            ? query.get('thirdChildActiveTab') ?? 'OptimisingEnergyConsumptionForEnvironmentalConsciousness_0'
            : subActiveTab === 'Features' 
            ? query.get('thirdChildActiveTab') ?? 'GOAL6CleanWaterAndSanitationForEnvironmentalConsciousness_0'
            : query.get('thirdChildActiveTab');
        let url = `/dedicated/corporate/sustainbility?activeTab=environmentalConsciousness&subActiveTab=${subActiveTab}`;
        if (thirdChildActiveTab) {
          url += `&thirdChildActiveTab=${thirdChildActiveTab}`;
        }
        navigate(url, { replace: true });
      } 
      if (activeTab === "creatinganInspiringWorkplace") {
        const subActiveTab = query.get('subActiveTab') ?? 'MainContent';
        const thirdChildActiveTab = 
          subActiveTab === 'SiderData'
            ? query.get('thirdChildActiveTab') ?? 'EnhancingWorkplaceEthicsandIntegrityForCreatingInspiringWorkplace_0'
            : subActiveTab === 'Features' 
            ? query.get('thirdChildActiveTab') ?? 'GOAL5GenderEqualityForCreatingInspiringWorkplace_0'
            : query.get('thirdChildActiveTab');
        let url = `/dedicated/corporate/sustainbility?activeTab=creatinganInspiringWorkplace&subActiveTab=${subActiveTab}`;
        if (thirdChildActiveTab) {
          url += `&thirdChildActiveTab=${thirdChildActiveTab}`;
        }
        navigate(url, { replace: true });
      }  
      if (activeTab === "communityFriendlyOrganisation") {
        const subActiveTab = query.get('subActiveTab') ?? 'MainContent';
        const thirdChildActiveTab = 
          subActiveTab === 'SiderData'
            ? query.get('thirdChildActiveTab') ?? 'CommunityEnrichmentYouthEmpowermentThroughEducationForCommunityFriendlyOrganisation_0'
            : subActiveTab === 'Features' 
            ? query.get('thirdChildActiveTab') ?? 'GOAL1NoPovertyForCommunityFriendlyOrganisation_0'
            : query.get('thirdChildActiveTab');
        let url = `/dedicated/corporate/sustainbility?activeTab=communityFriendlyOrganisation&subActiveTab=${subActiveTab}`;
        if (thirdChildActiveTab) {
          url += `&thirdChildActiveTab=${thirdChildActiveTab}`;
        }
        navigate(url, { replace: true });
      } 
      if (activeTab === "memorableAirportExperiences") {
        const subActiveTab = query.get('subActiveTab') ?? 'MainContent';
        const thirdChildActiveTab = 
          subActiveTab === 'SiderData'
            ? query.get('thirdChildActiveTab') ?? 'StrenghteningAirportSafetyandSecurityForMemorableAirportExperiences_0'
            : subActiveTab === 'Features' 
            ? query.get('thirdChildActiveTab') ?? 'GOAL9IndustryInnovationAndInfrastructureForMemorableAirportExperiences_0'
            : query.get('thirdChildActiveTab');
        let url = `/dedicated/corporate/sustainbility?activeTab=memorableAirportExperiences&subActiveTab=${subActiveTab}`;
        if (thirdChildActiveTab) {
          url += `&thirdChildActiveTab=${thirdChildActiveTab}`;
        }
        navigate(url, { replace: true });
      }  
      if(activeTab === 'ftse4good'){
        navigate(`/dedicated/corporate/sustainbility?activeTab=ftse4good&subActiveTab=${subActiveTab || 'ftse4goodMainContent'}`, {replace: true});
      }
      if(activeTab=== 'reports'){
        const subActiveTab = query.get('subActiveTab') ?? 'reportsMainContent';
        const thirdChildActiveTab = 
          subActiveTab === 'reportsFeatures' 
            ? query.get('thirdChildActiveTab') ?? 'SustainabilityReport2021ForReports_0'
            : query.get('thirdChildActiveTab');
        let url = `/dedicated/corporate/sustainbility?activeTab=reports&subActiveTab=${subActiveTab || 'reportsMainContent'}`;
        if (thirdChildActiveTab) {
          url += `&thirdChildActiveTab=${thirdChildActiveTab}`;
        }
        navigate(url, { replace: true });
      }
    }
  }, [query.get("activeTab"), query.get('subActiveTab'), query.get('thirdChildActiveTab')]);

  const items = [
    {
      label: "Landing",
      key: "landing",
      children: <Landing/>
    },
    {
      label: "Practising Sensible Economics",
      key: "practisingSensibleEconomics",
      children: <PracticingSensibleEconomics/>
    },
    {
      label: "Environmental Consciousness",
      key: "environmentalConsciousness",
      children: <EnvironmentalConsciousness/>
    },
    {
      label: "Creating an Inspiring Workplace",
      key: "creatinganInspiringWorkplace",
      children: <CreatingInspiringWorkplace/>
    },
    {
      label: "Community Friendly Organisation",
      key: "communityFriendlyOrganisation",
      children: <CommunityFriendlyOrganisation/>
    },
    {
      label: "Memorable Airport Experiences",
      key: "memorableAirportExperiences",
      children: <MemorableAirportExperiences/>
    },
    {
      label: "FTSE4 Good ",
      key: "ftse4good",
      children: <FTSE4Good/>
    },
    {
        label: "Reports",
        key: "reports",
        children: <Reports/>
      } 
    ];

  return (
    <ContentWrapper
      title={"Sustainability"}
    >
      <Tabs
        activeKey={query?.get("activeTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${activeKey}`);
        }}
      ></Tabs>
    </ContentWrapper>
  );
};

export default Sustainbility;
